var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnedited8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#010101;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.19,89.85c-0.65,0-1.28-0.35-1.61-0.97c-0.47-0.89-0.12-1.98,0.76-2.45 c19.72-10.36,30.87-22.24,28.39-30.25c-1.32-4.26-6.3-6.56-10.24-7.74c-0.96-0.29-1.51-1.3-1.22-2.26 c0.29-0.96,1.31-1.51,2.26-1.22c6.87,2.05,11.26,5.56,12.68,10.15c3.11,10.07-8.16,22.98-30.17,34.54 C116.77,89.78,116.48,89.85,116.19,89.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.24,108.97c-0.95,0-1.75-0.74-1.81-1.71c-0.06-1,0.7-1.86,1.7-1.92c11.52-0.7,24.47-3.18,37.45-7.2 c5.06-1.56,10.02-3.33,14.77-5.26c0.93-0.38,1.99,0.07,2.36,1c0.38,0.93-0.07,1.99-1,2.36c-4.84,1.96-9.91,3.77-15.06,5.36 c-13.25,4.1-26.5,6.64-38.3,7.35C49.31,108.97,49.27,108.97,49.24,108.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.14,107.76c-0.13,0-0.26-0.01-0.4-0.04c-8.53-1.91-13.9-5.67-15.51-10.88c-1.18-3.83-0.29-8.09,2.65-12.66 c0.54-0.84,1.67-1.09,2.51-0.55c0.84,0.54,1.09,1.67,0.54,2.51c-2.33,3.63-3.09,6.87-2.23,9.62c1.52,4.92,7.82,7.29,12.83,8.41 c0.98,0.22,1.59,1.19,1.38,2.17C29.72,107.19,28.97,107.76,28.14,107.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.65,119.67c-6.84,0-12.41-5.57-12.41-12.41c0-6.84,5.57-12.41,12.41-12.41s12.41,5.56,12.41,12.41 C51.05,114.1,45.49,119.67,38.65,119.67z M38.65,98.49c-4.84,0-8.77,3.94-8.77,8.77c0,4.84,3.94,8.77,8.77,8.77 s8.77-3.94,8.77-8.77C47.42,102.42,43.49,98.49,38.65,98.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.19,101.09c-5.3,0-9.62-4.31-9.62-9.62c0-5.3,4.31-9.62,9.62-9.62c5.3,0,9.62,4.31,9.62,9.62 C118.81,96.78,114.49,101.09,109.19,101.09z M109.19,85.49c-3.3,0-5.98,2.69-5.98,5.99c0,3.3,2.69,5.98,5.98,5.98 c3.3,0,5.99-2.69,5.99-5.98C115.18,88.17,112.49,85.49,109.19,85.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnedited8);
export default __webpack_public_path__ + "static/media/unedited8.c58e40d8cc73cd4477fa683a27acd99b.svg";
export { ForwardRef as ReactComponent };